import { connect } from 'react-redux';
import { denormalize } from 'normalizr';

import { schema } from '../../../../../state/schema';
import {
  loadCareGuideOwners,
  deleteCareGuideOwner,
} from '../../../../../state/modules/careGuideOwners/actions';
import { sendMessage } from '../../../../../state/actions';
import CareGuideOwnersList from '../components/CareGuideOwnersList';

const mapStateToProps = (state, ownProps) => {
  const page = ownProps.page;
  const limit = ownProps.limit;
  const order = ownProps.order;
  const result = state.careGuideOwners.getIn(['pages', order, limit, page]);

  return {
    list: result
      ? result
          .map((x) => {
            return {
              key: x,
              ...denormalize(
                state.entities.getIn(['careGuideOwners', x]),
                schema.careGuideOwner,
                state.entities.toJS()
              ),
            };
          })
          .toArray()
          .map((x) => {
            // flatten some nested objects to make table easier to work with
            return {
              profile_id: x?.profile?.id ?? '',
              profile_username: x?.profile?.user?.username ?? '',
              profile_email: x?.profile?.user?.email ?? '',
              ...x,
            };
          })
      : [],
    isLoading: state.careGuideOwners.get('isLoading'),
    total: state.careGuideOwners.get('total'),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    load: (page, limit, order, filter, cb) => {
      dispatch(loadCareGuideOwners(page, limit, order, filter, cb));
    },
    remove: (id, cb) => {
      dispatch(deleteCareGuideOwner(id, cb));
    },
    sendMessage: (level, title, body, expires) => {
      dispatch(sendMessage(level, title, body, expires));
    },
  };
};

const CareGuideOwnersListContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(CareGuideOwnersList);

export default CareGuideOwnersListContainer;
